import { Url } from '../shared/Url';
import Post from '../shared/Post';
import { PostPdf, PrintPdf } from '../shared/PostPdf';
import { cookieData } from '../funciones/ConsultaUser';

import { consultaUser } from './PefilFunction';

export const CarreraActual = (respuesta) => {
    consultaUser ((usuario) => {
        let Content = {
            id: usuario
        }
        Post(`${Url}carrerActual`, Content, (resp) => {
            let data = JSON.parse(resp)
            let state = {
                value: data[0].id_carrera, label: data[0].carrera_name
            }
            respuesta(state)
        });
    });
}

export const consultaSolicitudes = (respuesta) => {
    consultaUser ((usuario) => {
        let Content = {
            id: usuario
        }
        Post(`${Url}solicitudesNotasCert`, Content, (resp) => {
            let data = JSON.parse(resp);
            let status = 0;
            if (data[0].length === 0) status = 1;
            if (data[1] === 0) status = 1;
            if (data[1] > 0) status = 2;

            respuesta([data[0], status])
        });
    });
}

export const SolicitarNotasCert = (carrera, tipo, respuesta) => {
    let certificada = true;
    if (tipo === "simples") certificada = false;

    consultaUser ((usuario) => {
        let Content = {
            id: usuario,
            carrera: carrera,
            certificada: certificada
        }

        Post(`${Url}solicitarNotasCert`, Content, (resp) => {
            let data = JSON.parse(resp)
            respuesta (data)
        });
    });
}

export const SolicitarNotasCertDir = (carrera, tipo, est, respuesta) => {
    let certificada = true;
    if (tipo === "simples") certificada = false;

    cookieData((cookie) => {
        let Content = {
            uId: cookie[1],
            id: est,
            carrera: carrera,
            certificada: certificada
        }

        Post(`${Url}solicitarNotasCertDir`, Content, (resp) => {
            let data = JSON.parse(resp)
            respuesta (data)
        });
    });
}

export const ConsultNotasPendientes = (respuesta) => {
    cookieData((cookie) => {
        let Content = {
            uId: cookie[1],
        }

        Post(`${Url}consultaNotasPendientes`, Content, (resp) => {
            let data = JSON.parse(resp)
            respuesta(data[0])
        });
    });
}

export const NoAceptar = (id, respuesta) => {
    cookieData((cookie) => {
        let Content = {
            uId: cookie[1],
            id: id
        }

        Post(`${Url}NoApNotasPendientes`, Content, (resp) => {
            let data = JSON.parse(resp)
            respuesta(data)
        });
    });
}

export const AprobarNotas = (id, check, respuesta) => {
    cookieData((cookie) => {
        let Content = {
            uId: cookie[1],
            id: id,
            check: check
        }
        Post(`${Url}ApNotasPendientes`, Content, (resp) => {
            let data = JSON.parse(resp)
            respuesta(data)
        });
    });
}

export const GenerarNotas = (id, carrera, respuesta) => {
    cookieData((cookie) => {
        let Content = {
            uId: cookie[1],
            id: id,
            carrera: carrera
        }

        Post(`${Url}GenerarNotas`, Content, (resp) => {
            let data = JSON.parse(resp)
            respuesta(data)
        });
    });
}

export const ExportPdf = (dataHtml, callback) => {
    let Content = {
        dataHtml: dataHtml
    }
    PostPdf(`${Url}ExportPdf`, Content, (resp) => {
        callback(resp)
    })
}

export const PrinterPdf = (dataHtml, callback) => {
    let Content = {
        dataHtml: dataHtml
    }
    
    PrintPdf(`${Url}ExportPdf`, Content, () => {
        callback("ok")
    })
}

export const DownloadPdf = (dataHtml, nombre, callback)  => {
    let Content = {
        dataHtml: dataHtml
    }

    PostPdf(`${Url}ExportPdf`, Content, (resp) => {
        let a = document.createElement('a');
            a.href = resp;
            a.download = `${nombre}.pdf`;
            document.body.appendChild(a)
            a.click(); 
            a.remove();
            callback("ok")
    });
}


// WEBPACK FOOTER //
// ./src/funciones/NotasCertificadasFunction.jsx